<template>
  <div>
    <ContentHeader :stock-nav="true" :show-back="false" />

    <div class="content-container">
      <!-- 查询条件 -->
      <div class="query-panel">
        <div class="btn-line btn-line-right">
          <el-button
            class="btn-orange-plain"
            @click="handleExport()"
            size="small"
            >运单导出</el-button
          >
        </div>
        <el-form
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="运单编号">
                <el-input
                  v-model="queryParam.orderNumber"
                  placeholder="请输入运单编号"
                  class="panel-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出库单号">
                <el-input
                  v-model="queryParam.stockOrderNumber"
                  placeholder="请输入出库单号（模糊查询）"
                  class="panel-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="领用单号">
                <el-input
                  v-model="queryParam.quotaOrderNumber"
                  placeholder="请输入领用单号（模糊查询）"
                  class="panel-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请单号">
                <el-input
                  v-model="queryParam.stockApplyNumber"
                  placeholder="请输入申请单号（模糊查询）"
                  class="panel-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收货人">
                <el-input
                  v-model="queryParam.receivePerson"
                  placeholder="请输入收货人姓名"
                  class="panel-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="下单人">
                <el-input
                  v-model="queryParam.clientName"
                  placeholder="请输入下单人姓名"
                  class="panel-input"
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="运单状态">
                <el-select
                  v-model="queryParam.orderStatus"
                  placeholder="请选择运单状态"
                  clearable
                >
                  <el-option
                    v-for="option in logiticsStatusList"
                    :key="option.key"
                    :label="option.value"
                    :value="option.key"
                  />
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="是否自提">
                <el-select
                  v-model="queryParam.isSelfDelivery"
                  placeholder="请选择是否自提"
                  clearable
                >
                  <el-option label="自提" value="1" />
                  <el-option label="非自提" value="0" />
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="8">
              <el-form-item label="运单类型">
                <el-select
                  v-model="queryParam.orderType"
                  placeholder="请选择运单类型"
                  clearable
                >
                  <el-option label="出库" value="01" />
                  <el-option label="领用" value="02" />
                  <el-option label="申请" value="03" />
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="9">
              <el-form-item label="查询日期">
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.fromDate"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="startTimeStatus"
                    :picker-options="pickerOptionsStart"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.toDate"
                    type="date"
                    placeholder="截止日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="endTimeStatus"
                    :picker-options="pickerOptionsEnd"
                  />
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-line">
          <el-button class="btn-blue-plain" @click="searchQuery" size="small"
            >查询</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
        </div>
      </div>

      <!-- 数据显示 -->
      <div class="table-show" :loading="loading">
        <el-table
          :data="logiticsList"
          class="while-data-table"
          v-loading="loading"
        >
          <el-table-column prop="orderNumber" label="运单号"></el-table-column>
          <el-table-column
            prop="orderTypeName"
            label="类型"
            width="40"
          ></el-table-column>
          <el-table-column prop="sourceNumber" label="订单号"></el-table-column>
          <el-table-column
            prop="orderStatusName"
            label="订单状态"
          ></el-table-column>
          <el-table-column label="自提" width="40">
            <template slot-scope="scope">
              {{
                scope.row.isSelfDelivery === 1
                  ? "是"
                  : scope.row.isSelfDelivery === 0
                  ? "否"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="运单时间">
            <template slot-scope="scope">
              {{ scope.row.orderDate | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="receivePerson"
            label="收货人"
            width="60"
          ></el-table-column>
          <el-table-column label="收货地址" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="!scope.row.isSelfDelivery">
                {{ scope.row.receiveProvinceName }}
                {{ scope.row.receiveCityName }}
                {{ scope.row.receiveCountyName }}
                {{ scope.row.receiveAddress }}
              </span>
              <span v-else>自提</span>
            </template>
          </el-table-column>
          <el-table-column label="实际发货日期">
            <template slot-scope="scope">
              {{ scope.row.shipDate | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column label="物流公司-方式-单号">
            <template slot-scope="scope">

              <span>
                <!-- {{ getLogisticsCompany(scope.row.logisticsCompany) }} -->
                {{scope.row.logisticsCompanyName }}
                <i v-show="scope.row.logisticsTypeName && scope.row.logisticsCompanyName">-</i>
                {{ scope.row.logisticsTypeName }}
                <i
                  v-show="
                    scope.row.logisticsTypeName && scope.row.logisticsNumber
                  "
                  >-</i
                >
                {{ scope.row.logisticsNumber }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="logisticsTypeName"
            label="运输方式"
            width="60"
          ></el-table-column>
          <el-table-column
            prop="logisticsNumber"
            label="物流单号"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="receiptUser"
            label="签收人"
            width="60"
          ></el-table-column>
          <el-table-column label="实际签收日期">
            <template slot-scope="scope">
              {{ scope.row.receiptDate | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column> -->
          <el-table-column
            clign="center"
            label="操作"
            width="100"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleShow(scope.row)"
                  >查看</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div>
        <el-row class="while-data-table-footer">
          <el-col>
            <el-pagination
              background
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <v-form ref="form" :url="exportUrl" :params="exportParam" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import vForm from '@/components/v-form'
import { commonUtils } from '@/utils/common'
import ContentHeader from '@/components/content-header'
export default {
  name: 'stock-logitics',
  components: {
    ContentHeader,
    vForm
  },
  data () {
    return {
      loading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        orderNumber: '',
        orderStatus: '',
        fromDate: '',
        toDate: '',
        stockOrderNumber: '',
        quotaOrderNumber: '',
        stockApplyNumber: '',
        isSelfDelivery: '',
        orderType: '',
        receivePerson: '',
        clientName: ''
      },
      total: 0,
      exportParam: {},
      exportUrl: null,
      logiticsList: [],
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      logiticsOrder: {}
    }
  },
  computed: {
    ...mapState({
      logiticsStatusList: state => state.base.logisticsOrderStatusMap,
      logisticsCompanyList: state => state.base.logisticsCompanyMap
    })
  },
  activated () {
    this.getLogiticsList()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getDictByName', 'logisticsOrderStatusMap')
      this.$store.dispatch('getDictByName', 'logisticsCompanyMap')
      this.getLogiticsList()
    },

    // 获取运单列表
    getLogiticsList () {
      this.loading = true
      this.$store
        .dispatch('queryLogiticsList', this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.logiticsList = res.data.resultData.stockLogisticsList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 查看详情
    handleShow (row) {
      this.$router.push({
        path: '/stock/logitics/info',
        query: { logisticsId: row.logisticsId }
      })
    },

    // 导出
    handleExport () {
      this.exportUrl = commonUtils.getApiUrl('/stock/logistics/export/sheet')
      this.exportParam = Object.assign({}, this.queryParam)
      delete this.exportParam.page
      delete this.exportParam.pageSize
      this.$confirm('是否根据当前条件导出文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.form.submit()
        })
        .catch(() => {})
    },

    // 查询
    searchQuery () {
      this.getLogiticsList()
    },

    // 重置
    resetQuery () {
      this.queryParam = this.$options.data().queryParam
      this.getLogiticsList()
    },

    // 翻页
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getLogiticsList()
    },

    // 时间开始选择器
    startTimeStatus: function (value) {
      this.pickerOptionsEnd = {
        disabledDate: time => {
          let beginDateVal = this.queryParam.fromDate
          if (beginDateVal) {
            return (
              time.getTime() <= new Date(beginDateVal).getTime() - 86400000
            )
          }
        }
      }
    },
    // 时间结束选择器
    endTimeStatus: function (value) {
      this.pickerOptionsStart = {
        disabledDate: time => {
          let endDateVal = this.queryParam.toDate
          if (endDateVal) {
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      }
    },
    getLogisticsCompany (val) {
      let name = ''
      if (this.logisticsCompanyList) {
        this.logisticsCompanyList.forEach(item => {
          if (item.key === val) {
            name = item.value
          }
        })
      }
      return name || val
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-line {
  padding-top: 0;
}
.btn-line-right {
  text-align: right;
  margin-bottom: 10px;
}
</style>
